import axios from "axios";

export const createNewsWithImage = async (newsData, file) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const newsId = "NE" + timestamp;
    let imageUrl = "";

    if (file instanceof File) {
      const imgForm = new FormData();
      const renamedFile = new File([file], `${newsId}.jpg`, {
        type: file.type,
      });

      imgForm.append("file", renamedFile);
      imgForm.append("newsId", newsId);

      const uploadRes = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/api/news/img`,
        imgForm,
        {
          headers: {
            ...headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Raw fileName :", uploadRes);
      const fileName = uploadRes.data.name;
      imageUrl = `${process.env.REACT_APP_STORAGE_URL}${fileName}`;
      console.log("final URL : ", imageUrl);
    }

    const createRes = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/news/CreateNews`,
      {
        ...newsData,
        imageUrl,
        newsId,
      },
      { headers }
    );

    return { status: 200, appNewsId: createRes.data.appNewsId, imageUrl };
  } catch (err) {
    console.error("Error creating news with image:", err);
    return {
      status: err?.response?.status || 500,
      message: err?.response?.data?.detail || "Unexpected error",
    };
  }
};
